<template>
  <div class="m-15">
    <b-table striped bordered :busy="isBusy" hover :items="items" @row-clicked="rowHandler">
      <div slot="table-busy" class="text-center text-danger my-2">
        <strong>Carregando...</strong>
      </div>
    </b-table>
  </div>
</template>

<style>
.m-15 {
  margin: 15px;
}
</style>


<script>
import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "vincularpromocao",
  components: {},
  data: _ => {
    return {
      isBusy: false,
      items: []
    };
  },
  methods: {
    rowHandler(record, index, event) {
      localStorage.setItem("selecionado", record.codigo);
      localStorage.setItem("data_inicial", record.data_inicial);
      localStorage.setItem("data_final", record.data_final);
      this.$emit("can-continue", { value: true });
    }
  },
  async beforeMount() {
    this.isBusy = true;
    const options = { title: "Algo deu errado...", size: "sm" };
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/promocao/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        if (response.data.data.length > 0) {
          this.items = response.data.data;
          this.isLoading = false;
          this.isBusy = false;
        } else {
          this.$dialogs
            .alert("Não encontramos promoções no seu sistema Accesys.", options)
            .then(res => {
              this.$router.go(-1);
            });
        }
      })
      .catch(e => {
        console.error(e);
        this.isBusy = false;
        this.$dialogs
          .alert("Não encontramos promoções no seu sistema Accesys.", options)
          .then(res => {
            this.$router.go(-1);
          });
      });
  },
  mounted() {
    this.$emit("update:title", "titulo");
  }
};
</script>
